/** ! Dont use this; it's old */

import template from './pcIcon.html';

export default function pcIconDirective() {
  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      eventHandler: '&ngClick',
      icon: '@',
      viewBoxX: '@',
      viewBoxY: '@',
      viewBoxW: '@',
      viewBoxH: '@',
      textX: '@',
      textY: '@'
    },
    bindToController: true,
    controller: pcIconController,
    controllerAs: 'SvgIconCtrl'
  };
}

/* @ngInject */
function pcIconController($element) {
  // /////////////// //
  // Local Variables //
  // /////////////// //
  const vm = this;


  // //////////////// //
  // Public Variables //
  // //////////////// //
  vm.$onInit = () => {
    vm.viewBoxXVal = parseInt(vm.viewBoxX, 10);
    vm.viewBoxYVal = parseInt(vm.viewBoxY, 10);
    vm.viewBoxWVal = parseInt(vm.viewBoxW, 10);
    vm.viewBoxHVal = parseInt(vm.viewBoxH, 10);
    vm.textXVal = parseInt(vm.textX, 10);
    vm.textYVal = parseInt(vm.textY, 10);
  };
  vm.$postLink = () => {
    $element.get(0)
      .setAttribute('viewBox', `${vm.viewBoxXVal} ${vm.viewBoxYVal} ${vm.viewBoxWVal} ${vm.viewBoxHVal}`);
    $element.children().children()
      .get(0)
      .setAttribute('x', vm.textXVal);
    $element.children().children()
      .get(0)
      .setAttribute('y', vm.textYVal);
    $element.removeAttr('view-box-x view-box-y view-box-w view-box-h text-x text-y');
  };
}
